import StyleImage from "../models/StyleImage";
import StyleImagePrompt from '../models/StyleImagePrompt';
import StyleImageList from '../models/StyleImageList';
import StyleImageDescription from '../models/StyleImageDescription';
import apiClient from "../components/apiClient";

export class StyleImageService {
    static addStyleImage(styleImage: StyleImage) : Promise<StyleImage> {
        return apiClient.post<StyleImage>(`/StyleImage/AddStyleImage`, styleImage).then(res => res.data);
    }

    static getStyleImages(styleCode: string) : Promise<StyleImage[]> {
        return apiClient.get<StyleImage[]>(`/StyleImage/GetStyleImages/${styleCode}`).then(res => res.data);
    }
    
    static getStyleImageByDescription(description: StyleImageDescription) : Promise<StyleImage> {
        return apiClient.post<StyleImage>(`/StyleImage/GetStyleImageByDescription`, description).then(res => res.data);
    }

    static getImageList() : Promise<StyleImageList[]> {
        return apiClient.get<StyleImageList[]>(`/StyleImage/GetImageListing`).then(res => res.data);
    }

    static getStyleImagePrompts(styleCode: string) : Promise<StyleImagePrompt[]> {
        return apiClient.get<StyleImagePrompt[]>(`/StyleImage/GetStyleImagePrompts/${styleCode}`).then(res => res.data);
    }

    static deleteAllOptions(frontImageId: number, backImageId: number) : Promise<boolean> {
        return apiClient.delete<boolean>(`/StyleImage/DeleteAllOptions/${frontImageId}/${backImageId}`).then(res => res.data);
    }

    static clearFrontImage(styleCode: string) : Promise<boolean> {
        return apiClient.put<boolean>(`/StyleImage/ClearFrontImage/${styleCode}`).then(res => res.data);
    }

    static clearBackImage(styleCode: string) : Promise<boolean> {
        return apiClient.put<boolean>(`/StyleImage/ClearBackImage/${styleCode}`).then(res => res.data);
    }

    static updateStyleImage(styleImage: StyleImage) : Promise<boolean> {
        return apiClient.put<boolean>(`/StyleImage/UpdateStyleImage`, styleImage).then(res => res.data);
    }

    static addStyleImagePrompt(styleImagePrompt: StyleImagePrompt) : Promise<StyleImagePrompt> {
        return apiClient.post<StyleImagePrompt>(`/StyleImage/AddStyleImagePrompt`, styleImagePrompt).then(res => res.data);
    }

    static updateStyleImagePrompt(styleImagePrompt: StyleImagePrompt) : Promise<boolean> {
        return apiClient.put<boolean>(`/StyleImage/UpdateStyleImagePrompt`, styleImagePrompt).then(res => res.data);
    }

    static deleteStyleImagePrompt(styleImagePrompt: StyleImagePrompt) : Promise<boolean> {
        return apiClient.delete<boolean>(`/StyleImage/DeleteStyleImagePrompt/${styleImagePrompt.imageClr_Id}`).then(res => res.data);
    }
}